import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  NFTSolNFTMarket,
  NFTSolEnterprise,
  NFTSolMinting,
  NFTSolSmart,
  NFTSolEco,
  NFTSolArt,
} from "../../../app-constants";

function Nftsolutions() {
  return (
    <section
      className="nft_solutions_tek p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>NFT Development Solutions by TekRevol</h2>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="offset-lg-1">
            <p>
              We offer tailored NFT development solutions for various business
              ideas and project stages. We handle end-to-end projects or
              specific tasks to ensure your goals are met effectively.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="nft_solution_box">
              <div className="nft_solution_main">
                {/* <div className="num_title">
                  <h5>01</h5>
                </div> */}
                <div className="nft_solution_svg">{NFTSolNFTMarket}</div>
                <div className="nft_solution_head">
                  <h5>NFT Marketplace Development</h5>
                </div>
              </div>
              <p>
                Drawing upon our extensive experience in web development, we
                build C2C NFT marketplaces that focus on the consumer. Our
                concepts of navigation and processes leading to transactions are
                possible with safe payment options for the seller and buyer,
                alongside strong back-end support to deal with large traffic of
                transactions.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="nft_solution_box">
              <div className="nft_solution_main">
                {/* <div className="num_title">
                  <h5>02</h5>
                </div> */}
                <div className="nft_solution_svg">{NFTSolEnterprise}</div>
                <div className="nft_solution_head">
                  <h5>Enterprise NFT Platform Development</h5>
                </div>
              </div>
              <p>
                We focus on tokenizing the business assets to increase
                reliability and transparency in the complex multi-step, and
                multi-party transactions, such as value chains. With blockchain,
                we enable people to track, authenticate, and verify assets
                instantly, which minimizes fraud and enhances performance in
                intricate business environments.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="nft_solution_box">
              <div className="nft_solution_main">
                {/* <div className="num_title">
                  <h5>03</h5>
                </div> */}
                <div className="nft_solution_svg">{NFTSolMinting}</div>
                <div className="nft_solution_head">
                  <h5>NFT Minting Mechanism Development & Integration</h5>
                </div>
              </div>
              <p>
                Our team creates wide-ranging NFT selling and buying
                environments connected to other applications, for example, games
                or patent systems. More specifically, we concentrate on
                developing efficient and secure minting processes that allow
                repeated operations and protect the assets during their
                circulation.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="nft_solution_box">
              <div className="nft_solution_main">
                {/* <div className="num_title">
                  <h5>04</h5>
                </div> */}
                <div className="nft_solution_svg">{NFTSolSmart}</div>
                <div className="nft_solution_head">
                  <h5>NFT Smart Contract Development</h5>
                </div>
              </div>
              <p>
                We build smart contracts for Ethereum and other blockchains that
                are resilient to common attack vectors with the OpenZeppelin
                library and services. Our smart contracts are intended for
                decentralized and self-executing agreements to eliminate the
                possibility of errors and conformity to legal requirements.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="nft_solution_box">
              <div className="nft_solution_main">
                {/* <div className="num_title">
                  <h5>05</h5>
                </div> */}
                <div className="nft_solution_svg">{NFTSolEco}</div>
                <div className="nft_solution_head">
                  <h5>NFT Ecosystem Testing</h5>
                </div>
              </div>
              <p>
                Our integrated testing ensures we give you highly accurate and
                verified NFT software by addressing the UI and blockchain
                applications. Functional testing of all the parts of the site is
                conducted, transactional aspects are tested, data validity is
                verified, and all features work smoothly for the user.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="nft_solution_box">
              <div className="nft_solution_main">
                {/* <div className="num_title">
                  <h5>06</h5>
                </div> */}
                <div className="nft_solution_svg">{NFTSolArt}</div>
                <div className="nft_solution_head">
                  <h5>NFT Art Tokenization</h5>
                </div>
              </div>
              <p>
                We offer NFT art tokenization services that enable artists and
                creators to tokenize their digital and physical artwork. It
                includes creating unique tokens for each piece of art, ensuring
                authenticity and provenance. Meanwhile, we also integrate the
                tokens with various NFT marketplaces.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nftsolutions;
